import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.25,
  mb: 1.5,
};

export const userBlock: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  minWidth: 0,
  flex: 1,
};

export const userText: SxStyle = {
  minWidth: 0,
};
